export const MARKET_COUNTRY_CODE = "bm-market";
